/**
 * Headless host that wires native push notifications into the signed-in app:
 *   - silent token registration (when permission already granted)
 *   - the permission prime after the first pick
 *   - tap → deep-link handling (warm + cold start)
 *
 * Renders nothing. Mount once inside the authenticated provider tree.
 */
import { usePushRegistration } from '../hooks/usePushRegistration'
import { usePushPermissionPrime } from '../hooks/usePushPermissionPrime'
import { usePushNotificationResponse } from '../hooks/usePushNotificationResponse'

export function PushNotificationsHost(): null {
  const { requestPushPermission } = usePushRegistration()
  usePushPermissionPrime(requestPushPermission)
  usePushNotificationResponse()
  return null
}
